import React from 'react'
import { isMobile } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelFlexBox,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import { getShipmentMethods } from 'utils/api-routes.util'
import PlusIcon from 'utils/icons/plus-icon'

import AddNewShipment from './component/AddNewshipment'

const columns = [
  {
    dataKey: 'title',
    name: 'Title',
    sortable: true,
    selector: (row) => row.title,
  },
  {
    dataKey: 'source',
    name: 'Source Id',
    sortable: true,
    selector: (row) => row.source,
  },
  {
    dataKey: 'description',
    name: 'Description',
    sortable: true,
    wrap: true,
    minWidth: '700px',
    selector: (row) => row.description,
  },
  {
    dataKey: 'last_synced_at',
    name: 'Last Synced At',
    sortable: true,
    selector: (row) => row.last_synced_at,
  },
]
const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'Shipping Methods',
    active: true,
  },
]
const ShipmentMethods = () => {
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [ShipmentMethods, setShipmentMethods] = React.useState<any>([])
  const [tableLoading, setTableLoading] = React.useState(true)

  const getAllShipmentMethods = () => {
    setTableLoading(true)
    getShipmentMethods().subscribe((res: any) => {
      setShipmentMethods(res.response.data)

      setTableLoading(false)
    })
  }
  React.useEffect(() => {
    getAllShipmentMethods()
  }, [])

  const handleCloseModal = (data: any, action) => {
    if (action === 'add') {
      setShipmentMethods([data, ...ShipmentMethods])
    }
    setShowNewModal(false)
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <PixelFlexBox
              justifyContent="flex-end"
              width="100%"
              height="auto"
              padding=" 5px 20px"
            >
              <DcButton
                onClick={() => {
                  setShowNewModal(true)
                }}
                size="sm"
              >
                <PlusIcon color="#fff" size={18} /> Add{' '}
                {!isMobile && 'Shipment Method'}
              </DcButton>
            </PixelFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
          isMobile={isMobile}
        >
          <SectionContent isMobile={isMobile}>
            <PixelTable
              columns={columns}
              data={ShipmentMethods}
              progressPending={tableLoading}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 212px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcOverlaySlider
        title={'Create Shipping Method'}
        onClose={() => setShowNewModal(false)}
        isOpen={showNewModal}
        width="40%"
      >
        <SectionContent>
          {showNewModal && <AddNewShipment handleClose={handleCloseModal} />}
        </SectionContent>
      </DcOverlaySlider>
    </>
  )
}

export default ShipmentMethods
